import React from 'react';
import './NavBar.css';
import { Home, ShoppingBag, Users, Settings } from 'lucide-react';
import { useGame } from '../utils/GameContext';
import { useAuth } from '../utils/AuthContext';
import { useAudio } from '../utils/AudioContext'; 
import { playUiHoverSound, playUiClickSound } from '../utils/sounds'; // Changed import

function NavBar({ activeTab, onHome, onShop, onFriends, onSettings }) {
    const { gameState } = useGame();
    const { notificationCount } = useAuth(); 
    const { sfxMuted } = useAudio(); 
    
    const isVisible = gameState === 'ready';

    const handleNavClick = (callback) => {
        playUiClickSound(sfxMuted); // Use random click for navigation
        callback();
    };

    return (
        <div className={`nav-bar-container ${!isVisible ? 'exit' : ''}`}>
            <div className="nav-bar">
                <button 
                    className={`nav-item ${activeTab === 'home' ? 'active' : ''}`} 
                    onClick={() => handleNavClick(onHome)}
                    onMouseEnter={() => playUiHoverSound(sfxMuted)}
                >
                    <Home size={28} strokeWidth={2.5} />
                    <span className="nav-label">Home</span>
                </button>
                
                <button 
                    className={`nav-item ${activeTab === 'shop' ? 'active' : ''}`} 
                    onClick={() => handleNavClick(onShop)}
                    onMouseEnter={() => playUiHoverSound(sfxMuted)}
                >
                    <ShoppingBag size={28} strokeWidth={2.5} />
                    <span className="nav-label">Shop</span>
                </button>
                
                <button 
                    className={`nav-item ${activeTab === 'friends' ? 'active' : ''}`} 
                    onClick={() => handleNavClick(onFriends)}
                    onMouseEnter={() => playUiHoverSound(sfxMuted)}
                >
                    <div className="icon-wrapper" style={{ position: 'relative' }}>
                        <Users size={28} strokeWidth={2.5} />
                        {notificationCount > 0 && (
                            <span className="nav-badge"></span>
                        )}
                    </div>
                    <span className="nav-label">Friends</span>
                </button>
                
                <button 
                    className={`nav-item ${activeTab === 'settings' ? 'active' : ''}`} 
                    onClick={() => handleNavClick(onSettings)}
                    onMouseEnter={() => playUiHoverSound(sfxMuted)}
                >
                    <Settings size={28} strokeWidth={2.5} />
                    <span className="nav-label">Settings</span>
                </button>
            </div>
        </div>
    );
}

export default NavBar;